import * as z from "zod";

export const getVolumeByLocation = {
  name: "getVolumeByLocation" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    locations: z.array(z.object({ location: z.string(), volume: z.number() })),
  }),
};
